import type { Brief, Startup } from "@crucible/types";

export interface ApiClientOptions {
  baseUrl: string;
  orgSlug?: string | null;
  fetchImpl?: typeof fetch;
}

export function createApiClient({
  baseUrl,
  orgSlug,
  fetchImpl = fetch,
}: ApiClientOptions) {
  const root = baseUrl.replace(/\/$/, "");

  async function request<T>(path: string, init?: RequestInit): Promise<T> {
    const headers = new Headers(init?.headers);
    if (orgSlug) headers.set("X-Org-Slug", orgSlug);

    const res = await fetchImpl(`${root}${path}`, { ...init, headers });
    if (!res.ok) {
      throw new Error(`API ${res.status}: ${path}`);
    }
    return res.json() as Promise<T>;
  }

  return {
    health: () => request<{ status: string }>("/healthz"),
    listStartups: () => request<Startup[]>("/api/startups"),
    getBrief: (slug: string) => request<Brief>(`/api/startups/${slug}/brief`),
  };
}

export type ApiClient = ReturnType<typeof createApiClient>;